import { render, staticRenderFns } from "./gateWayOrderMange.vue?vue&type=template&id=bfa185ce&"
import script from "./gateWayOrderMange.vue?vue&type=script&lang=js&"
export * from "./gateWayOrderMange.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\work\\admin\\datacenter_web\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('bfa185ce')) {
      api.createRecord('bfa185ce', component.options)
    } else {
      api.reload('bfa185ce', component.options)
    }
    module.hot.accept("./gateWayOrderMange.vue?vue&type=template&id=bfa185ce&", function () {
      api.rerender('bfa185ce', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/gateway/gateWayOrderMange.vue"
export default component.exports